import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-login-header',
  templateUrl: './login-header.component.html',
  styleUrls: ['./login-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginHeaderComponent {
  @Input() showBrandLockup = false;
  @Input() productLogoUrl = '';
  @Input() poweredByLogoUrl = '';
  @Input() poweredByUrl = 'https://aerostudies.com/';
  @Input() tagline = 'Your Ascent workspace.';

  @Output() supportClick = new EventEmitter<void>();
}
